import React from "react"
import Layout from "../components/Layout"
import Seo from "../components/Frontend/Seo"
import HeaderColor from "../components/Frontend/HeaderColor"
import FooterDefault from "../components/Footer"
import { Row, Col } from "antd"
import styled from "styled-components"

const PageContainer = styled.div`
  max-width: 720px;
`

const IndexPage = () => {
  return (
    <Layout>
      <Seo title={`หน้าแรก | คอร์สออนไลน์ - เว็บไซต์คาเฟ่`} description={``} />
      <HeaderColor />
      <PageContainer>
        <div className="gb--container">
          <Row>
            <Col span={24}></Col>
          </Row>
        </div>
      </PageContainer>
      <FooterDefault />
    </Layout>
  )
}

export default IndexPage
